import Auth from "./auth_reducer"
import App from "./app_reducer"

const reducers = {
  Auth,
  App,
}

export default reducers
